var _rect, _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEditIconNew(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    rx: 12,
    fill: "#F4F4F4"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 17.4999H7C6.86739 17.4999 6.74021 17.4472 6.64645 17.3535C6.55268 17.2597 6.5 17.1325 6.5 16.9999V14.207C6.5 14.1414 6.51293 14.0764 6.53806 14.0157C6.56319 13.955 6.60002 13.8999 6.64645 13.8535L14.1464 6.35348C14.2402 6.25971 14.3674 6.20703 14.5 6.20703C14.6326 6.20703 14.7598 6.25971 14.8536 6.35348L17.6464 9.14637C17.7402 9.24014 17.7929 9.36732 17.7929 9.49992C17.7929 9.63253 17.7402 9.75971 17.6464 9.85348L10 17.4999Z",
    stroke: "#0E5AA7",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5 8L16 11.5",
    stroke: "#0E5AA7",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.5004 17.5004H10.0004L6.53223 14.0322",
    stroke: "#0E5AA7",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditIconNew);
export default __webpack_public_path__ + "static/media/edit-icon-new.058ac53daf114ec04f51b4b26324c3be641d6c063ba4bee9160ed352c1ecb7e0.svg";
export { ForwardRef as ReactComponent };